
import { Button } from 'primereact/button';
import React, { useContext, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import count_days from '../../functions/count_days';
import sum_total_paid from '../../functions/sum_total_paid';
import sum_total_price from '../../functions/sum_total_price';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';
import FooterInvoice from './FooterInvoice';
import HeaderInvoice from './HeaderInvoice';
import { InvoiceContext } from './Invoice_Context';
import './invoice.css';

function InvoiceCustomerDelete()
{
    const data = useContext(InvoiceContext)
    const componentRef = useRef();
    const buttonRef = useRef();
    // eslint-disable-next-line no-unused-vars
    const [isShown, setIsShown] = useState(false);
    return (
    <div>
        <div id="invoice" className="page page-content fade-in-up" dir="rtl" style={{margin:"auto",maxWidth:"850PX"}} ref={componentRef}>
            <div className="ibox invoice-print">
                <div className="invoice-header">
                    <div className="row">
                        <div className="col-12">
                            <HeaderInvoice title={"فاتــورة حجــوزات الملغيــة"}></HeaderInvoice>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-6" style={{borderLeft:"1px solid rgba(0,0,0,.1"}}>
                                        <div className="m-b-5 font-bold">بيانات الزبون</div>
                                        <ul className="list-unstyled m-t-10">
                                            <li className="m-b-5">
                                                <span className="font-strong"> الأسم  :</span> {data.customer.visitor_name} </li>
                                            <li className="m-b-5">
                                                <span className="font-strong"> الهاتف :</span> {data.customer.phone_number}</li>
                                        </ul>
                                    </div>

                                    <div className="col-6"  style={{borderRight:"1px solid rgba(0,0,0,.1"}}>
                                        <div className="m-b-5 font-bold">بيانات الحجز</div>
                                            <ul className="list-unstyled m-t-10">
                                            <li className="m-b-5">
                                                <span className="font-strong"> عدد الحجوزات :</span> {data.reservations.length} </li>
                                            <li className="m-b-5">
                                            <span className="font-strong"> عدد الأيام :</span> {count_days(data.reservations)}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>

                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                <table className="table table-bordered table-striped no-margin table-invoice">
                    <thead className="color-view ">
                        <tr >
                            <th>الحجز</th>
                            <th>الشالية</th>
                            <th>الأيام</th>
                            <th colSpan={2} style={{textAlign:"center"}} >
                             الدخول - المغادرة
                            </th>
                            <th>السعر</th>
                            <th>الإجمالي</th>
                            <th>المدفوع</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.reservations.map((res)=>{
                                return(
                                <tr>
                                    <td>{res.ID_reservation}</td>
                                    <td>
                                        <div>
                                        <small>{view_apartment_type_ar(res)}</small><strong>{"-"+ res.number}</strong>
                                        </div>
                                        <small>{res.number_people} أشخاص </small>
                                    </td>
                                    <td>{count_days([res])} أيام</td>
                                    <td style={{color:"green"}}>
                                        <div>
                                            <strong>{res.date_check_in} </strong>
                                        </div>
                                        <small> {view_day_ar(res.date_check_in)} </small>
                                    </td>
                                    <td style={{color:"green"}}>
                                        <div>
                                            <strong>{res.date_check_out}  </strong>
                                        </div>
                                        <small>  {view_day_ar(res.date_check_out)} </small>
                                    </td>
                                    <td>{res.price_day}  د.ل</td>
                                    <td>{res.total_price} د.ل</td>
                                    <td>{res.total_paid} د.ل</td>
                                </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
                </div>
                <table className="table no-border">
                    <thead>
                    {/* <th width="15%"></th> */}
                        <tr>
                            <td className="font-bold font-18 text-center">إجمالي المبلغ  </td>
                            <td className="font-bold font-18 text-center">إجمالي المدفوع  </td>
                        </tr>

                    </thead>
                    <tbody style={{borderBottom:"1px solid #ddd"}}>
                        <tr >
                            <td  className="font-bold font-18 text-center" style={{padding:"1px"}}>{sum_total_price(data.reservations)}
                                 د.ل</td>
                            <td className="font-bold font-18 text-center" style={{padding:"1px"}}>{sum_total_paid(data.reservations)} د.ل</td>
                        </tr>

                        {
                            data.total_amount ?
                            (
                                <tr className="text-center" >
                                    <td  className="font-bold font-18 text-left" > القيمة المسترجعة </td>
                                    <td className="font-bold font-18 text-right">{data.total_amount} د.ل</td>
                                </tr>
                            )
                            :
                            (null)
                        }
                    </tbody>
                </table>
            </div>
            <FooterInvoice></FooterInvoice>
        </div>
        <div className="text-center">
            <ReactToPrint
                trigger={
                    () =>  <Button dir='ltr' type="button"  label=" طبــاعة "  icon='fa fa-print' raised
                    ref={buttonRef}  onClick={(e)=> setIsShown(current => !current)}
                    />
                }
                content={() => componentRef.current}
            />
        </div>
    </div>
    );
}
export default InvoiceCustomerDelete;